import _ from 'lodash'
import {
  FILTER_ALL,
  FILTER_RISK,
  FILTER_MODIFIED,
} from 'containers/Project/Specifications/constants'

export const applyUnitsToProps = (moduleData) => {
  for (const property in moduleData) {
    if (!moduleData.hasOwnProperty(property)) continue

    applyUnits(moduleData[property])
  }

  return moduleData
}
/**
 *
 * Add units to values in elements of initValues and modifiedValues
 * Note that this function changes moduleData given in.
 *
 * @param {any} moduleData
 * @returns modified moduleData
 */
export const applyUnits = (moduleData) => {
  const {
    units,
    initValues,
    modifiedValues,
  } = moduleData
  let newInit = initValues
  let newModified = modifiedValues

  for (const item in units) {
    if (!units.hasOwnProperty(item)) continue

    const unit = units[item]

    newInit =
      newInit ? newInit.map(value => value ? {
        ...value,
        [item]: value[item] ? `${value[item]} ${unit}` : null,
      } : null) : null
    newModified =
      newModified ? newModified.map(value => value ? {
        ...value,
        [item]: value[item] ? `${value[item]} ${unit}` : null,
      } : null) : null
  }

  moduleData.initValues = newInit
  moduleData.modifiedValues = newModified

  return {
    ...moduleData,
    initValues: newInit,
    modifiedValues: newModified,
  }
}
/**
 *
 * Apply predicate to the initValues and modifiedValues fields of moduleData.
 * Note that this function changes moduleData given in.
 *
 * @param {any} moduleData
 * @param {function} predicate
 * @returns modified moduleData
 */
export const updateModuleData = (moduleData, predicate) => {
  if (!moduleData) return

  moduleData.initValues = moduleData.initValues ? predicate(moduleData.initValues) : null
  moduleData.modifiedValues = moduleData.modifiedValues ? predicate(moduleData.modifiedValues) : null

  return moduleData
}

export const isValueRisk = (risks, value) => (
  risks.filter(risk => risk.risk === 'Risk').some(risk => value >= risk.min && value <= risk.max)
)

export const getCurStatus = (risk, initValue, modifiedValue) => (
  risk ? FILTER_RISK : initValue !== modifiedValue ? FILTER_MODIFIED : null
)

/**
 *
 * Determines if the SpecItem should be hidden or not.
 * If both initial value and modified value are empty in modified page, hide the field.
 * If modified value is empty in spec page, hide the field.
 * If the status of value does not correspond with selected filter in spec page, hide the field.
 *
 * @param {boolean} isModifiedPage
 * @param {any} modifiedValues
 * @param {any} initValues
 * @param {boolean} risk
 * @param {string} curFilter
 * @returns true if SpecItem should be hidden, false otherwise
 */
export const hideSpecItem = (isModifiedPage, modifiedValue, initValue, risk, curFilter) => {
  const curStatus = getCurStatus(risk, initValue, modifiedValue)
  const filtered = isModifiedPage && curFilter !== FILTER_ALL && curFilter !== curStatus
  return (isModifiedPage && !initValue && !modifiedValue) ||
         (!isModifiedPage && !modifiedValue) || filtered
}
